import { useEffect, useState } from 'react';
import AdsApi from '../api/ads';

const cached = {};

/**
 * A status filter's groups ({ value, label, tone }) from the API, fetched once per page load: delivery statuses,
 * or with type 'ad_account' the ad account statuses
 */
export default function useStatusGroups(type = '') {
  const [groups, setGroups] = useState([]);
  useEffect(() => {
    let current = true;
    cached[type] ??= AdsApi.statuses(type).then((data) => data.results).catch(() => {
      delete cached[type];
      return [];
    });
    cached[type].then((results) => current && setGroups(results));
    return () => {
      current = false;
    };
  }, [type]);
  return groups;
}
